/* global define, google, window, getDummyData, MarkerClusterer, alert */

define('views/MasterView',[
    'jquery',
    'backbone',
    'underscore',
    'bootstrap',
    'views/TopSearchBarView',
    'views/AdvancedSearchBarView',
    'views/MapView',
    'views/DrawingView',
    'views/OverlaysView',
    'views/PropertyView',
    'views/SearchResultView',
    'views/TourView',
    'views/SearchControlsView',
    'markerclusterer',
    'gmapsoverlays',
    'cookie'
], function($, Backbone, _, Bootstrap, TopSearchBarView, AdvancedSearchBarView, MapView, DrawingView, OverlaysView, PropertyView, SearchResultView, TourView, SearchControlsView) {

    'use strict';

    var View = Backbone.View.extend({

        markers: [],
        el: '#masterView',
        className: 'masterView',
        markerLookup: {},
        searchDelayTimer: null,
        searchStarted: false,
        events: {
            'click .viewOnMapButton': 'onViewOnMap',
            'click .viewAsListButton': 'onViewAsList',
            'click .nextPropertyButton': 'onNextProperty',
            'click .previousPropertyButton': 'onPreviousProperty',
            'click .resetButton': 'onReset'
        },
        searchForm: {},
        updateParentForm: function(name, value) {

            //console.log('update form', name, value, this.searchForm);

            //console.log(name, value);
            this.searchForm[name] = value;
            //console.log(this.searchForm);

            if (window.parent === undefined ||
                window.parent.document.SearchForm === undefined) {
                //console.warn('missing parent form');
                return;
            }

            if (!this.$parentForm) {
                this.$parentForm = $(window.parent.document.SearchForm);
            }

            if(name === "finishSearch"){
                return;
            }

            var $field = this.$parentForm.find('input[name=\'' + name + '\']');

            if ($field.length === 0) {
                $field = $('<input type="hidden">');
                //$field = $('<input type="text">');
                this.$parentForm.append($field);
            }

            $field.attr('name', name);
            $field.val(value);

        },
        initialize: function() {

            // Bind All
            _.bindAll(this);

            var gmapsearch = null;

            if (window.parent !== undefined && window.parent.gmapsearch !== undefined) {
                gmapsearch = window.parent.gmapsearch;
            } else {
                gmapsearch = {};
                gmapsearch.showHelpCallouts = false;
                gmapsearch.advanced_panel_height = 200;
                gmapsearch.advanced_panel_width = 400;
                gmapsearch.advanced_panel_columns = 3;
                gmapsearch.center_lat = 48.912765088728676;
                gmapsearch.center_lng = -123.76922607421875;
                gmapsearch.map_zoom = 8;
                gmapsearch.max_zoom = 20;
                gmapsearch.min_zoom = 11;
                gmapsearch.map_boundary_sw = [48.221, -125.391];
                gmapsearch.map_boundary_ne = [50.071, -123.009];
            }

            gmapsearch.max_zoom = 17;

            var _this = this;

            if (window.parent !== undefined) {

                var previousFunction = window.parent.__runFormSearch;

                window.parent.__runFormSearch = function() {
                    if (previousFunction) {
                        previousFunction();
                    }
                    _this.onSearch(true);
                };
            }

            this.gmapsearch = gmapsearch;

            //console.log(gmapsearch);

            this.mapView = new MapView({
                gmapsearch: gmapsearch
            });

            this.drawingView = new DrawingView({
                mapView: this.mapView
            });

            this.topSearchBarView = new TopSearchBarView({
                gmapsearch: gmapsearch
            });

            this.advancedSearchBarView = new AdvancedSearchBarView({
                gmapsearch: gmapsearch
            });

            this.overlaysView = new OverlaysView({
                gmapsearch: gmapsearch
            });

            this.searchControlsView = new SearchControlsView({});

            this.tourView = new TourView({});

            // TODO CLEAN ME


            this.drawingView.bind('tour', function() {
                _this.tourView.drawTour();
            });
            this.drawingView.bind('map-fit-bounds', function(bounds) {
                _this.mapView.fitBounds(bounds);
            });
            this.drawingView.bind('change', this.updateParentForm);
            this.drawingView.bind('clear-all', this.clearAll);
            this.drawingView.bind('clear-markers', this.clearMarkers);

            this.overlaysView.bind('tour', function() {
                _this.tourView.overlaysTour();
            });
            this.overlaysView.bind('selection-changed', function() {

                var formData = _this.overlaysView.getFormData();

                for (var key in formData) {
                    var value = formData[key];
                    if (value != _this.searchForm[key]) {
                        _this.updateParentForm(key, formData[key]);
                    }
                }

            });
            this.overlaysView.bind('drawer-opened', this.closePropertyWindow);
            this.overlaysView.bind('map-show', function(shape) {
                var map = _this.mapView.getMap();
                shape.setMap(map);
            });
            this.overlaysView.bind('map-fit-bounds', function(bounds) {
                _this.mapView.fitBounds(bounds);
            });
            this.overlaysView.bind('map-zoom-increment', function() {
                _this.mapView.setZoom(_this.mapView.getZoom() + 1);
            });
            this.overlaysView.bind('map-strick-bounds', function(strictBounds) {
                _this.mapView.setStrictBounds(strictBounds);
            });
            this.topSearchBarView.bind('search', function() {
                _this.clearMarkers();
                _this.onSearch(true);
            });
            this.topSearchBarView.bind('change', function(name, value) {
                _this.clearMarkers();
                _this.searchStarted = false;
                _this.updateParentForm(name, value);
            });
            this.topSearchBarView.bind('fullscreen', function(enabled) {
                if (enabled) {
                    _this.searchControlsView.$el.show();
                } else {
                    _this.searchControlsView.$el.hide();
                }
            });

            this.topSearchBarView.bind('toggleAdvancedOptions', this.toggleAdvancedOptions);


            this.topSearchBarView.bind('showOverlays', this.showOverlaysView);
            this.topSearchBarView.bind('hideOverlays', this.hideOverlaysView);

            this.advancedSearchBarView.bind('change', this.updateParentForm);

            this.mapView.bind('change', this.updateParentForm);
            this.mapView.bind('bounds-changed', function(map) {

                var bounds = map.getBounds(),
                    zoom = map.getZoom();



                if (zoom === gmapsearch.max_zoom) {

                    // CLEAN THIS SHIT UP
                    // TODO Cache this

                    if (!_this.oldStyle) {
                        _this.oldStyle = _this.markerCluster.getStyles();
                    }

                    var style = {};
                    style.height = 45;
                    style.width = 15;
                    style.textColor = 'white';
                    style.url = 'img/pins/pin_custom.png';

                    //http://google-maps-utility-library-v3.googlecode.com/svn/trunk/markerclustererplus/images/m3.png

                    _this.markerCluster.setStyles([style]);
                    _this.markerCluster.setMap(null);
                    _this.markerCluster.setMap(map);
                } else {
                    //_this.markerCluster.setMap(map);
                    if (_this.oldStyle && _this.markerCluster.getStyles().length === 1) {
                        _this.markerCluster.setStyles(_this.oldStyle);
                        _this.markerCluster.setMap(null);
                        _this.markerCluster.setMap(map);
                    }
                }

                /*if(_this.disableSearch){
					console.log('c');
					return;
				}*/

                // If bounds change then perform search
                if (!_this.previousBounds || !_this.previousBounds.equals(bounds)) {

                    // TODO implement MODE


                    if (!_this.isOverlayVisible() && !_this.drawingView.getOverlay() &&
                        _this.searchStarted &&
                        !_this.gmapsearch.autosearch_nodrag) {

                        //

                        clearInterval(_this.searchDelayTimer);
                        _this.searchDelayTimer = setInterval(

                            function() {
                                _this.previousBounds = bounds;
                                _this.onSearch(false);
                                clearInterval(_this.searchDelayTimer);
                            }, 100);

                    }
                }


            });

            this.overlaysView.bind('error', this.onError);

            // this should be moved in render
            this.$el.hide();

            this.$el.append(this.topSearchBarView.render().el);
            this.$el.append(this.advancedSearchBarView.render().el);
            this.$el.append(this.mapView.render().el);
            this.$el.append(this.drawingView.render().el);
            this.$el.append(this.overlaysView.render().el);
            this.$el.append(this.searchControlsView.render().el);

            this.overlaysView.$el.hide();

            this.$propertyInfoWindowTemplate = $('#property_info_window_tempalte');

            // This should be changed
            this.map = this.mapView.getMap();

            // Marker Clustor
            this.markerCluster = new MarkerClusterer(this.map, [], {
                zoomOnClick: true,
                gridSize: 25,
                /*minimumClusterSize:3,*/
                maxZoom: gmapsearch.max_zoom,
                imagePath : "/wps/img/mobile/v5/m"
            });

            var onClustorClick = this.onClustorClick,
                markerCluster = this.markerCluster;
            google.maps.event.addListener(this.markerCluster, 'click', function(event) {

                if (event.getMap().getZoom() === markerCluster.getMaxZoom()) {

                    onClustorClick(event);
                }

            });

            this.$spinner = this.$el.find('#spinner');
            this.$mapCanvas = this.$el.find('#map_canvas');
            this.$topSearchBarView = $('#topSearchBarView');
            this.$window = $(window);

            this.$window.on('resize', this.resizeMap);

            this.forwardToList = true;


            setTimeout(function(){
                //this.mapView.on('idle', function() {
                    if (window.parent !== undefined &&
                        window.parent.gmapsearch_autosearch_onstartup === true) {
                        _this.forwardToList = false;
                        _this.onSearch(false);
                    }
                //});
            }, 1000);

        },
        resizeMap: function() {

            // TODO move to render()

            var windowWidth = this.$window.width(),
                windowHeight = this.$window.height(),
                topHeight = this.$topSearchBarView.height(),
                mapHeight = this.$window.height() - topHeight - 2;

            this.$topSearchBarView.css('left', '1px');
            this.$topSearchBarView.css('top', '0px');
            this.$topSearchBarView.width(windowWidth - 2);

            this.$el.width(windowWidth - 2);
            this.$el.height(windowHeight - 2);

            this.$mapCanvas.css('top', topHeight + 'px');
            this.$mapCanvas.height(mapHeight);
            this.$mapCanvas.width(windowWidth - 2);


            this.drawingView.update();


        },
        render: function() {

            var width = this.$window.width() - 2,
                _this = this,
                gmapsearch = this.gmapsearch,
                mapView = this.mapView;

            this.$el.width(width);
            this.$el.show();

            this.resizeMap();

            var mapReady = function() {

                //console.log(gmapsearch);
                if (gmapsearch.free_poly_points) {

                    _this.drawingView.drawFreePoly({
                        type: gmapsearch.free_poly_type,
                        points: gmapsearch.free_poly_points,
                        spec: gmapsearch.free_poly_spec
                    });
                } else if (gmapsearch.overlaySelections) {
                    _this.showOverlaysView();
                }

                // Tour
                if (!$.cookie('skip-tour')) {
                    _this.tourView.drawTour();
                }
                $.cookie('skip-tour', 'true', {
                    expires: 365,
                    path: '/'
                });


                mapView.off('idle', mapReady);
            };

            mapView.on('idle', mapReady);


            if(gmapsearch.autofullscreen){
                this.$el.find(".fullscreenButton i").click();
            }

            return this;
        },
        showAdvanceOptions: function() {
            this.advancedSearchBarView.show();
        },
        hideAdvanceOptions: function() {
            this.advancedSearchBarView.hide();
        },
        toggleAdvancedOptions: function() {
            this.advancedSearchBarView.toggle();
        },
        showOverlaysView: function() {
            this.onReset();
            this.overlaysView.show();
            this.topSearchBarView.enableOverlays();
            this.drawingView.hide();
            this.mapView.hideZoomControls();

            this.mapView.setMinZoom(1);

            this.clearAll();
        },
        isOverlayVisible: function() {
            if (this.overlaysView.$el.is(':visible')) {
                return true;
            }
            return false;
        },
        hideOverlaysView: function() {

            if (!this.isOverlayVisible()) {
                return;
            }

            this.onReset();
            this.overlaysView.hide();
            this.topSearchBarView.disableOverlays();
            this.drawingView.show();
            this.mapView.showZoomControls();

            this.mapView.setMinZoom(this.gmapsearch.min_zoom);
        },
        onError: function(message) {
            // TODO make a nice error dialog
            alert(message);
        },
        onReset: function() {
            this.topSearchBarView.reset();
            this.advancedSearchBarView.reset();
            this.mapView.reset();
            this.overlaysView.reset();
            this.clearAll();
            this.searchStarted = false;
        },
        onSearch: function(showResults) {

            /*if(this.propertyWindow){
				this.propertyWindow.close();
				this.propertyWindow = null;
			}*/

            // If search is already in progress then cancel
            if (this.searchResultsView &&
                this.searchResultsView.isVisible()) {
                return;
            }

            // Rest back to hand on search
            this.drawingView.onHand();

            //this.clearMarkers();

            var _this = this;

            // TODO fix this migrate overlaysearch to event updates
            //

            if (this.overlaysView.$el.is(':visible')) {
                this.overlaysView.onSearch(function(formData) {

                    for (var key in _this.searchForm) {
                        formData[key] = _this.searchForm[key];
                    }

                    _this.search(formData, false, showResults);
                });
            } else {

                this.search(this.searchForm, false, showResults);

                /*
				this.mapView.onSearch(function(formData) {
					_this.search(formData, false, showResults);
				});*/
            }

        },
        search: function(formData, forceClear, showResults) {

            var listedDate = $('#listedDate', window.parent.document).val(),
                openHouse = $('#openHouse', window.parent.document).val(),
                priceReduction = $('#priceReduction', window.parent.document).prop('checked');

            formData.listedDate = listedDate;
            formData.openHouse = openHouse;
            formData.priceReduction = priceReduction;

            this.searchStarted = true;
            this.$spinner.show();

            var gmapsearch = this.gmapsearch,
                formControllerUrl = gmapsearch.form_controller_url,
                map = this.map,
                _this = this;

            var paramString = '';
            var params = {};
            var keyValues = null;
            var keyValue = null;

            if (formControllerUrl.indexOf('?') >= 0) {
                paramString = formControllerUrl.substring(formControllerUrl.indexOf('?') + 1);

                keyValues = paramString.split('&');

                for (var i = 0; i < keyValues.length; i++) {
                    keyValue = keyValues[i].split('=');
                    params[keyValue[0]] = decodeURIComponent(keyValue[1]);
                }
            }

            for (var key in params) {
                formData[key] = params[key];
            }

            formControllerUrl = formControllerUrl.substring(0, formControllerUrl.indexOf('?'));

            formData.r = Math.random();
            formData.center_lat = map.getCenter().lat();
            formData.center_lng = map.getCenter().lng();
            formData.map_zoom = map.getZoom();

            var bounds = map.getBounds();
            formData.sw_lat = bounds.getSouthWest().lat();
            formData.sw_lng = bounds.getSouthWest().lng();
            formData.ne_lat = bounds.getNorthEast().lat();
            formData.ne_lng = bounds.getNorthEast().lng();

            this.cancelSearch = false;

            if (!this.searchResultsView) {
                this.searchResultsView = new SearchResultView();
                this.searchResultsView.bind('cancel', function() {
                    _this.cancelSearch = true;
                });
                this.searchResultsView.bind('viewMap', function() {
                    _this.onViewOnMap();
                });
                this.searchResultsView.bind('viewList', function() {
                    _this.onViewAsList();
                });
            }

            var searchResultsView = null;

            if (showResults) {
                searchResultsView = this.searchResultsView;
                searchResultsView.render();
            }
            // TODO CACHE

            $.ajax({
                type: 'POST',
                url: formControllerUrl,
                data: formData,
                success: function(data /*, textStatus, jqXHR*/ ) {

                    if (_this.cancelSearch) {
                        _this.$spinner.hide();
                        return;
                    }

                    var values = data.split('|');
                    gmapsearch.seachResultsUrl = values[2];

                    if (forceClear) {
                        _this.clearAll();
                    }

                    if (showResults) {

                        if (values[1] === '1' && values[3]) {
                            searchResultsView.setMaxResults(values[3]);
                            //searchResultsView.disableViewOnMap();
                        } else {
                            searchResultsView.setMaxResults(0);
                        }

                        searchResultsView.setCount(values[0]);
                    } else {
                        _this.onViewOnMap();
                    }

                    _this.$spinner.hide();

                    return;

                }
            });

        },
        onViewAsList: function() {

            var windowUrl = window.parent.location.href,
                searchResultsUrl = this.gmapsearch.seachResultsUrl,
                start = 0,
                end = 0;

            if (windowUrl.indexOf('/w/w=') === -1) {
                end = windowUrl.indexOf('/', 8);
            } else {
                end = windowUrl.indexOf('/', windowUrl.indexOf('/w/w=') + 4);
            }

            windowUrl =
                windowUrl.substring(start, end) +
                '/' + searchResultsUrl;

            window.parent.location.href = windowUrl;

        },
        onViewOnMap: function() {

            var gmapsearch = this.gmapsearch,
                data = {
                    forMap: true,
                    r: Math.random()
                },
                _this = this;


            var url = gmapsearch.form_controller_url.substring(0,
                gmapsearch.form_controller_url.indexOf('Search.form'));

            url += 'browse/SearchResults.form';

            /*var progressDialog = new ProgressDialogView({
				title:'Loading',
				message:'Loading properties, please wait...'
			});
			progressDialog.show();
			progressDialog.setPercent(100);*/

            $.ajax({
                type: 'GET',
                data: data,
                url: url,
                success: function(data /*, textStatus, jqXHR*/ ) {

                    var response;

                    try {
                        response = JSON.parse(data);
                    } catch (err) {

                        if (_this.forwardToList === true) {

                            _this.onViewAsList();
                            return;
                        }

                        _this.forwardToList = true;
                    }

                    if (!response) {
                        return;
                    }

                    var isOverlayVisible = _this.overlaysView.$el.is(':visible');

                    if (isOverlayVisible) {
                        _this.hideOverlaysView();
                    }

                    _this.addPropertyMarkers(response.results);
                    _this.overlaysView.hideAnchors();
                    _this.disableSearch = true;

                    if (_this.drawingView.getOverlay()) {
                        //_this.drawingView.zoomToOverlay();
                    } else if (isOverlayVisible) {
                        //_this.zoomToAllMarkers();
                        _this.overlaysView.zoomToSelectedRegions();

                    }

                    _this.mapView.bind('idle', function() {
                        _this.disableSearch = false;
                    });

                    //progressDialog.hide();
                }
            });
        },
        openPropertyWindow: function(markers, sort) {

            if (!markers || markers.length === 0) {
                return;
            }

            if (sort) {
                this.sortMarkers(markers[0]);
            }

            if (this.propertyWindow) {
                this.closePropertyWindow();
            }

            this.propertyWindow = new PropertyView({
                property: markers[0].property,
                markers: markers,
                offsetLeft: this.mapView.$el.find('#map_canvas').offset().left,
                offsetTop: this.mapView.$el.find('#map_canvas').offset().top,
                map: this.map,
                resource_server: this.gmapsearch.resource_server,
                form_controller_url: this.gmapsearch.form_controller_url
            });

            this.propertyWindow.open();
            this.map.panTo(markers[0].getPosition());
            this.map.panBy(0, -$('#propertyWindowOverlay').height() / 2);
        },
        closePropertyWindow: function() {
            if (this.propertyWindow) {
                this.propertyWindow.close();
                this.propertyWindow = null;
            }
        },
        onClustorClick: function(cluster) {
            this.openPropertyWindow(cluster.getMarkers(), true);
        },
        addPropertyMarkers: function(properties) {

            if (!properties || properties.length === 0) {
                return;
            }

            var markers = [],
                marker = null;

            for (var i = 0; i < properties.length; i++) {

                marker = this.addPropertyMarker(properties[i]);

                if (marker) {
                    markers.push(marker);
                }
            }

            this.markerCluster.addMarkers(markers);

        },
        addPropertyMarker: function(property) {

            if (this.markerLookup[property.LIST_ID]) {
                return null;
            }


            this.markerLookup[property.LIST_ID] = property;

            //http://localhost:8080/wps/rest/10053/l/recip/16655/attribution?firstOnly=true&_cb=JSONCallback327
            //JSONCallback327( "Coldwell Banker Premier Realty", 16655 );

            var latLng = new google.maps.LatLng(
                property.LATITUDE,
                property.LONGITUDE);

            var icon = 'img/pins/pin1.png';

            var marker = new google.maps.Marker({
                /*map: this.map,*/
                position: latLng,
                //icon: "img/markers/" + property.PROPERTY_TYPE + ".png",
                icon: icon,
                shadow: 'img/pins/shadow.png',
                zIndex: 99
            });
            marker.setZIndex(99);

            marker.property = property;

            var openPropertyWindow = this.openPropertyWindow;

            google.maps.event.addListener(marker, 'click', function() {
                openPropertyWindow([marker], true);
            });

            this.markers.push(marker);

            return marker;
        },
        clearAll: function() {
            this.clearMarkers();
            this.clearOverlays();
        },
        clearMarkers: function() {

            if (!this.markerCluster) {
                return;
            }

            this.markerCluster.clearMarkers();

            for (var i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }

            this.markers = [];
            this.markerLookup = {};

        },
        clearOverlays: function() {

            this.drawingView.clearOverlay();

            /*

			if (this.searchOverlay) {
				this.searchOverlay.setMap(null);
			}
			this.searchOverlay = null;*/

            /*$.each(this.overlays, function(i, overlay) {
				overlay.setMap(null);
			});
			this.overlays = [];*/
        },
        sortMarkers: function(marker) {

            var lat = marker.getPosition().lat(),
                lng = marker.getPosition().lng(),
                R = 6371,
                distances = [],
                i = 0,
                closest = -1;

            function rad(x) {
                return x * Math.PI / 180;
            }

            for (i = 0; i < this.markers.length; i++) {
                var mlat = this.markers[i].position.lat(),
                    mlng = this.markers[i].position.lng(),
                    dLat = rad(mlat - lat),
                    dLong = rad(mlng - lng),
                    a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2),
                    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
                    d = R * c;

                this.markers[i].distance = d;

                distances[i] = d;
                if (closest === -1 || d < distances[closest]) {
                    closest = i;
                }
            }

            // Bubble Sort
            var swapped;
            do {
                swapped = false;
                for (i = 0; i < this.markers.length - 1; i++) {
                    if (this.markers[i].distance > this.markers[i + 1].distance) {
                        var temp = this.markers[i];
                        this.markers[i] = this.markers[i + 1];
                        this.markers[i + 1] = temp;
                        swapped = true;
                    }
                }
            } while (swapped);

            $.each(this.markers, function(index, marker) {
                marker.index = index;
            });

        },
        zoomToAllMarkers: function() {

            // this doesn't work because data is not great
            /*
			if (!this.markers || this.markers.length === 0) {
				return;
			}

			var bounds = new google.maps.LatLngBounds(),
				marker = null;

			for (var i = 0; i < this.markers.length; i++) {
				marker = this.markers[i];

				if (marker.getPosition().lat() !== 0 && marker.getPosition().lng() !== 0) {
					bounds.extend(marker.getPosition());
				}
			}

			this.map.fitBounds(bounds);*/

        },
        onNextProperty: function(event) {

            var index = $(event.currentTarget).attr('rel');

            index++;

            if (index >= this.markers.length) {
                index = 0;
            }

            var marker = this.markers[index];

            this.openPropertyWindow(marker, false);
        },
        onPreviousProperty: function(event) {

            var index = $(event.currentTarget).attr('rel');

            index--;

            if (index < 0) {
                index = this.markers.length - 1;
            }

            var marker = this.markers[index];

            this.openPropertyWindow(marker, false);
        }
    });
    return View;
});

